module.exports = __webpack_public_path__ + "847fb34925429e67cd2626e8534c152a.svg";